import { patchState, signalStore, withComputed, withMethods, withProps, withState } from "@ngrx/signals";
import { inject } from "@angular/core";
import { UserStore } from "../../../../stores/user.store";
import { FlsStore } from "../../../../stores/fls.store";
import { StateStore } from "../../../../services/state/state.store";
import { S25States } from "../../../../services/state/state.map";
import { StudentEngagementOrg } from "../../StudentEngagementOrg";
import { Nullable } from "../../../../pojo/Util";

type SearchState = {
    selectedIds: Set<number>;
    emailOrg: Nullable<StudentEngagementOrg.SeOrgTile>;
};

export const SeObjectSearchStore = signalStore(
    withState<SearchState>({
        selectedIds: new Set<number>(),
        emailOrg: null,
    }),
    withProps(() => ({
        _userStore: inject(UserStore),
        _fls: inject(FlsStore),
        _state: inject(StateStore),
    })),
    withComputed((store) => ({
        isMyOrgs: () => store._state.currentSeState() === S25States.names.seMyOrgs,
        isMyEvents: () => store._state.currentSeState() === S25States.names.seMyEvents,
        isDash: () => store._state.currentSeState() === S25States.names.seHomeView,
        isOrgSearchPage: () => store._state.currentSeState() === S25States.names.seOrganizationsSearch,
    })),
    withComputed((store) => ({
        isAdmin: () => store._fls.hasFull("STUDENT_ENGAGEMENT") && store.isOrgSearchPage(),
        contactIdParam: () => (store.isMyOrgs() || store.isMyEvents() ? store._userStore.id() : undefined),
    })),
    withMethods((store) => ({
        selectId: (id: number) =>
            patchState(store, (state) => ({
                selectedIds: new Set(state.selectedIds).add(id),
            })),
        deSelectId: (id: number) =>
            patchState(store, (state) => {
                if (!state.selectedIds.has(id)) return {};
                const next = new Set(state.selectedIds);
                next.delete(id);
                return { selectedIds: next };
            }),
        selectAll: (ids: number[]) => patchState(store, () => ({ selectedIds: new Set(ids) })),
        deSelectAll: () => patchState(store, () => ({ selectedIds: new Set() })),
        openEmailSidebar: (org: StudentEngagementOrg.SeOrgTile) => patchState(store, { emailOrg: { ...org } }),
        closeEmailSidebar: () => patchState(store, { emailOrg: null }),
    })),
);
